// extracted by mini-css-extract-plugin
module.exports = {"container":"classes_container__2r3xS","commits":"classes_commits__1Xr0n","icon":"classes_icon__3Xxik"};